import { useMemo, useState } from 'react'

import { SaveToListSheet } from './SaveToListSheet'
import { SaveToListContext } from './saveToListContext'
import type { SaveToListTarget } from './saveToListContext'

/**
 * Holds which favourite the Save to list sheet is open for and renders the
 * sheet. Keyed by favourite so each open starts fresh (form closed, list
 * order taken anew).
 */
export function SaveToListProvider({ children }: { children: React.ReactNode }) {
  const [target, setTarget] = useState<SaveToListTarget | null>(null)
  const value = useMemo(() => ({ openSaveToList: setTarget }), [])

  return (
    <SaveToListContext.Provider value={value}>
      {children}
      {target && (
        <SaveToListSheet
          key={target.favouriteId}
          target={target}
          onClose={() => setTarget(null)}
        />
      )}
    </SaveToListContext.Provider>
  )
}
